import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

function TabPanel(props) {
  const { id, labelledby, children, _value, _index, selected, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={!selected}
      id={id}
      aria-labelledby={labelledby}
      sx={{ display: 'flex', flexDirection: 'column' }}
      {...other}
    >
      {selected && children}
    </Box>
  );
}

TabPanel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default TabPanel;
